'use client';
import React from 'react';
import { QA, QAProps } from '../QA/index';
import styles from './styles.module.scss';

export interface FAQProps {
  faqData: QAProps[];
  title?: string;
}

export const FAQ: React.FC<FAQProps> = ({ faqData }) => {
  return (
    <div className={styles['faq-container']}>
      <div className={styles['faq-block']}>
        {faqData.map((faq: QAProps) => (
          <QA answer={faq.answer} key={faq.question} question={faq.question} />
        ))}
      </div>
    </div>
  );
};
